import BrainsTable from "../../../features/ai/llm-rag/components/table/BrainsTable";

function BrainsList() {
    return <BrainsTable />;
}

export default BrainsList;
